import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";

import ModalHolder from "../../molecules/ModalHolder";
import { toastWarning } from "../../../shared/helpers";
import { CreateScheduleFormOne, CreateScheduleFormTwo } from "../../templates/Case";

const CreateCaseScheduleModal = ({ closeModal, _case, showSuccessModal }) => {
  const [step, setStep] = useState(1);
  const [fields, setFields] = useState({});

  const updateFields = (data) => {
    setFields({ ...fields, ...data });
    setStep(2);
  };

  const onCreateSchedule = (data) => {
    toastWarning("Cannot perform this action on Demo mode");
  };

  const formCtx = useForm({
    validateCriteriaMode: "all",
  });

  return (
    <ModalHolder width="60%" closeModal={closeModal}>
      <FormProvider {...formCtx}>
        {step === 1 && (
          <CreateScheduleFormOne
            closeModal={closeModal}
            fields={fields}
            updateFields={updateFields}
          />
        )}
        {step === 2 && (
          <CreateScheduleFormTwo
            closeModal={closeModal}
            fields={fields}
            onCreateSchedule={onCreateSchedule}
          />
        )}
      </FormProvider>
    </ModalHolder>
  );
};

export default CreateCaseScheduleModal;
